import { render } from "./PersonalGoalModal.vue?vue&type=template&id=49cc8702&ts=true"
import script from "./PersonalGoalModal.vue?vue&type=script&lang=ts"
export * from "./PersonalGoalModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__